import { Input, InputGroup } from "@chakra-ui/react";
import React, { ChangeEvent, ReactNode, useRef } from "react";
import { hasValue, isNullish } from "../../../../lib/util/common-util";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";

export type CMButtonFileUploadProps = {
  onUpload: (files: File[]) => void;
  accept?: string;
  multiple?: boolean;
  isUploading?: boolean;

  children?: ReactNode;
} & ComponentStyleProps;

// 参考: https://gist.github.com/Sqvall/23043a12a7fabf0f055198cb6ec39531
/**
 * ファイルアップロードを行うコンポーネント。
 */
export const CMButtonFileUpload = ({
  onUpload,
  accept,
  multiple,
  isUploading = false,

  children,
  sx,
  ...rest
}: CMButtonFileUploadProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const handleClick = () => inputRef.current?.click();

  const handleChange = (ev: ChangeEvent<HTMLInputElement>) => {
    const fileList = ev.target.files;
    if (isNullish(fileList)) return;

    const files = Array.from(fileList);
    if (files.length === 0) return;

    if (hasValue(inputRef.current)) {
      inputRef.current.value = null as any;
    }

    onUpload(files);
  };

  return (
    <InputGroup onClick={handleClick} sx={sx} {...rest}>
      <Input
        type="file"
        multiple={multiple || false}
        hidden
        accept={accept}
        onChange={handleChange}
        disabled={isUploading}
        ref={inputRef}
      />
      <>{children}</>
    </InputGroup>
  );
};
